import { tv } from "../../../variants/tv.js";
const calendarVariants = tv({
    slots: {
        root: 'relative box-border bg-primary-1',
        monthCaption: 'flex w-full items-center justify-center py-2',
        buttonPreviousContainer: 'absolute top-0 left-0 flex cursor-pointer',
        buttonNextContainer: 'absolute top-0 right-0 flex cursor-pointer',
        buttonPrevious: 'h-8 w-8',
        buttonNext: 'h-8 w-8',
        captionLabel: 'text-heading5 text-primary-13 capitalize',
        nav: '',
        months: 'relative flex [&>div:not(:first-of-type)]:ml-4',
        month: 'flex flex-col',
        weekdays: 'py-2',
        weekRow: [
            ''
        ],
        weekHeader: [
            ''
        ],
        daysGrid: [
            ''
        ],
        weeks: '',
        week: '',
        weekday: 'h-11 w-11 text-body3 text-primary-10',
        weekNumber: '',
        day: [
            'focus-visible:outline-none',
            'aspect-square h-11 w-11 text-body1'
        ],
        dayButton: [
            'h-full max-h-11 w-full',
            'box-border flex cursor-pointer items-center justify-center rounded-lg text-body1 text-neutral-11',
            'hover:bg-primary-4 hover:text-neutral-12',
            'focus-visible:rounded-lg focus-visible:ring-2 focus-visible:ring-primary-8 focus-visible:outline-none focus-visible:ring-inset',
            'disabled:cursor-not-allowed disabled:text-neutral-6 disabled:hover:bg-transparent'
        ],
        today: '',
        outsideDay: 'text-neutral-8',
        selectedDays: [
            'selected-day [&>button]:bg-primary-8 [&>button]:text-primary-1 [&>button]:hover:bg-primary-8 [&>button]:hover:text-primary-1',
            '[&>button]:focus-visible:rounded-lg [&>button]:focus-visible:ring-3 [&>button]:focus-visible:ring-primary-11 [&>button]:focus-visible:outline-none [&>button]:focus-visible:ring-inset'
        ],
        rangeStart: [
            'range-start',
            '[&>button]:rounded-tr-none [&>button]:rounded-br-none'
        ],
        rangeMiddle: [
            'range-middle',
            '[&>button]:bg-primary-11 [&>button]:text-primary-1 [&>button]:hover:bg-primary-11 [&>button]:hover:text-primary-1',
            '[&>button]:rounded-none'
        ],
        rangeEnd: [
            'range-end',
            '[&>button]:rounded-tl-none [&>button]:rounded-bl-none'
        ],
        chevron: 'inline-block h-5 w-5 fill-primary-8',
        dropdowns: '',
        dropdown: '',
        dropdownRoot: '',
        monthGrid: '',
        holidayRoot: 'flex w-full flex-col items-start gap-1',
        holidayListItem: 'flex flex-row items-center gap-1 text-left text-body3 text-neutral-10',
        disabled: 'cursor-not-allowed text-neutral-6',
        hidden: 'invisible',
        focusable: ''
    },
    variants: {
        heatMapVariant: {
            day: {},
            dayIcon: {},
            dayHeatMap: {
                day: 'h-12',
                dayButton: 'flex max-h-12 flex-col justify-start border-1 border-primary-1 py-[2px]'
            },
            dayBelowAvg: {
                day: 'h-12',
                dayButton: 'flex max-h-12 flex-col justify-start py-1'
            }
        },
        colorVariant: {
            DEFAULT: {
                dayButton: ''
            },
            EXCELLENT: {
                dayButton: 'bg-success-3'
            },
            GOOD: {
                dayButton: 'bg-caution-3'
            },
            HIGH: {
                dayButton: 'bg-error-3'
            }
        },
        hasHoliday: {
            true: {
                day: 'h-12',
                dayButton: 'flex max-h-12 flex-col justify-start py-1'
            }
        },
        isMobile: {
            true: {
                root: 'w-full',
                months: 'flex flex-col gap-1 [&>div:not(:first-of-type)]:ml-0',
                monthCaption: 'justify-start'
            }
        }
    }
});
export { calendarVariants };
